import axios from "axios";
import { API_BASE_URL } from "../../../../../../../../../../Helpers/apiConfig";

const BASE_URL = `${API_BASE_URL}/admin/ContentManager`;

/**
 * Genel İçerik Güncelleme Servisi
 * @param {Object} data - Güncellenecek tüm içerik verisi
 * @param {string} token - Kullanıcı yetkilendirme token'ı
 */
export const updateContent = async (data, token) => {
    try {
        const response = await axios({
            method: 'POST',
            url: `${BASE_URL}/Update`,
            headers: {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: data
        });

        if (response.status === 200) {
            return response.data; // success: true/false ve message buradan döner
        }
        throw new Error("Sunucu yanıt vermedi.");
    } catch (error) {
        throw error;
    }
};